import {
    ChartJsDoughnut,
    type ChartJsDoughnutDataType,
    ReactGridContainer,
    useL2DTheme,
} from '@europrocurement/flexy-components';
import React, { useEffect, useState } from 'react';
import { type ResizeHandleAxis } from 'react-grid-layout';
import { type DossierOpenSearchJsonldOpensearchDossierStatutRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { Box, lighten } from '@mui/material';
import { useStatusStyle } from '@europrocurement/l2d-modules/hooks';
import TasksDashboardWidget from '../TasksDashboardWidget/TasksDashboardWidget';

const RESIZE_HANDLES: ResizeHandleAxis[] = ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'];

const LAYOUT = [
    {
        i: 'list-tasks-formalist',
        x: 0,
        y: 0,
        w: 1,
        h: 6,
        isResizable: true,
        resizeHandles: RESIZE_HANDLES,
    },
    {
        i: 'chartJs-doughnut-formalist',
        x: 0,
        y: 6,
        w: 1,
        h: 6,
        isResizable: true,
        resizeHandles: RESIZE_HANDLES,
    },
];

type TasksAndChartWidgetDashboardProps = {
    statusDossierOpenSearch?: DossierOpenSearchJsonldOpensearchDossierStatutRead[];
    formalistIds: number[];
    showResetButton?: boolean;
};

const TasksAndChartWidgetDashboard: React.FunctionComponent<TasksAndChartWidgetDashboardProps> =
    function ({ statusDossierOpenSearch, formalistIds, showResetButton }) {
        const { palette } = useL2DTheme();
        const { getDossierStatusStyle } = useStatusStyle();
        const [chartData, setChartData] = useState<ChartJsDoughnutDataType>();

        useEffect(() => {
            if (statusDossierOpenSearch) {
                const newChartData: ChartJsDoughnutDataType = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Nombre de dossiers',
                            data: [],
                            backgroundColor: [],
                            borderWidth: 1,
                        },
                    ],
                };

                statusDossierOpenSearch.map((status) => {
                    const statusStyle = getDossierStatusStyle(status.id as number);

                    const sxColor = (statusStyle?.sxStatus as { color?: string })?.color;
                    const bgColor = sxColor ? lighten(sxColor, 0.8) : statusStyle.color;
                    newChartData.labels.push(status.libelle as string);
                    newChartData.datasets[0].data.push(status.childsCount as number);
                    newChartData.datasets[0].backgroundColor.push(bgColor);
                    return true;
                });
                setChartData(newChartData);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [statusDossierOpenSearch]);

        return (
            <Box sx={{ overflow: 'hidden' }}>
                <ReactGridContainer
                    localStorageName="grid-widgets-formalist"
                    showResetButton={showResetButton}
                    gridconfig={{ cols: 1, rowHeight: 50 }}
                    layoutProps={LAYOUT}
                >
                    <Box
                        key="list-tasks-formalist"
                        sx={{
                            height: '100%',
                            borderColor: palette.divider,
                            borderRadius: '8px',
                            padding: '0px 8px',
                        }}
                    >
                        <TasksDashboardWidget formalistIds={formalistIds} />
                    </Box>
                    <Box
                        key="chartJs-doughnut-formalist"
                        sx={{ height: '100%' }}
                    >
                        {chartData && <ChartJsDoughnut data={chartData} />}
                    </Box>
                </ReactGridContainer>
            </Box>
        );
    };

export default TasksAndChartWidgetDashboard;
